import { Pipe, PipeTransform } from '@angular/core';
import { Tag } from '@isophi/pap-api';
import { CompetenceChip, competenceChips } from '../components/portfolio-plan-competence/competence-groups';

/** `competences | competenceChips: availableCompetences` - numbered, area-tinted overview chips. */
@Pipe({
  name: 'competenceChips',
  standalone: false,
})
export class CompetenceChipsPipe implements PipeTransform {
  transform(competences: Tag[] | null | undefined, tags?: Tag[] | null): CompetenceChip[] {
    return competenceChips(competences ?? [], tags ?? []);
  }
}
